import { useState } from 'react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';
import { useOnCurrentAudioTrackChanged } from '@/scenarios/legacy-player/hooks/useOnCurrentAudioTrackChanged';

import { AudioTrack } from '../types/instance';

export const useCurrentAudioTrack = () => {
    const instance = usePlayerInstance();
    const [currentAudioTrack, setCurrentAudioTrack] = useState<AudioTrack | undefined>(
        () => instance?.audioTrack
    );

    useOnCurrentAudioTrackChanged(setCurrentAudioTrack);

    return currentAudioTrack;
};
